export enum CommonResultId {
  Progress = 412,
  Winner = 411,
  Result = 2,
  RegularTime = 3,
  Penalty = 7,
  Overtime = 104,
}
